import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper'
import forwardAllocationComp from "./forwardallocation";
import ReverseAllocationComp from "./Reverseallocation";
import ReverseAllocationCompv2 from "./Reverseallocationv2/index.vue";
import ReverseAllOFP from "./ReverseAllOFP/index.vue";
import ReverseConfirmAllocation from "./ReverseConfirmAllocation/index.vue";
import { NewAllocationConfigFlag as NewAllocationFlag, getHubDeliverySRListByHubID as getHubDeliverySRListByHubID, getMissingRvpShipmentByHubID as getMissingRvpShipmentByHubID} from '../../../../services/modules/newallocationservices.js';
export default {
    name: 'newallocationpage',
    components: {
        VueElementLoading,
        'forward-allocation': forwardAllocationComp,
        'Reverse-allocation': ReverseAllocationComp,
        'Reverse-allocationv2': ReverseAllocationCompv2,
        'Reverse-allofp': ReverseAllOFP,
        'Reverse-confirmallocation': ReverseConfirmAllocation,
    },
    props: [],
    mixins: [PageTracker],
    data() {
        return {
            ActiveTabIndex: 0,
            IsRVP: true,
            IsDelivery: true,
            userDataKey: '',
            onOFFUsers: false,
            srArrayList: [],
            srList: [],
            rvpUserLoading:false,
            hyperVMsgData: null,
            layout: "half", // Options: 'half', 'first', 'second'
            Ismissingshipmentflag:true
        }
    },
    computed: {
        firstClass() {
            return this.layout === "first" ? "col-sm-12" : this.layout === "half" ? "col-sm-6" : "d-none";
          },
          secondClass() {
            return this.layout === "second" ? "col-sm-12" : this.layout === "half" ? "col-sm-6" : "d-none";
          },
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        //this.userDataKey = 'Key';
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.username = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
        this.GetNewAllocationFlags();
            //For RVP new Allcoation Flag
        // if (['43685', '42624'].includes(this.userid)) {
        //     this.onOFFUsers = true
        // } else {
        //     this.onOFFUsers = false
        // }
    },
    methods: {
        show(which) {
            return this.layout === which || this.layout === "half";
        },
        expand(which) {
            this.layout = which;
        },
        collapse() {
            this.layout = "half";
        },
        SwitchTabs(Param){
            if(Param == 'RVP'){
                this.GetDeliverySRList(this.userHubId)
                let hubidsArr = window.localStorage.getItem('missinghubids');
                let cacheArray = hubidsArr.split(",").map(Number); 
                if (this.Ismissingshipmentflag && !cacheArray.includes(Number(this.userHubId)) && ![9780,9003].includes(Number(this.userHubId))) {
                    this.GetMissingShippmentList(this.userHubId,this.Ismissingshipmentflag)
                }
            }
        },
        GetNewAllocationFlags() {
            // this.IsDelivery = true
            // this.IsRVP = false
            let Payload = { "hubid": this.userHubId }
            NewAllocationFlag(Payload, (result) => {
                if (result.data.data == true) {
                    this.IsDelivery = true
                    this.IsRVP = true
                    this.Ismissingshipmentflag = true
                } else if (result.data.data == false) {
                    this.IsDelivery = false
                    this.IsRVP = false
                    this.Ismissingshipmentflag = false
                } else {
                    this.IsDelivery = (result.data.data.isnewallocationconfig.deliveryv2) ? true : false
                    this.IsRVP = result.data.data.isnewallocationconfig.rvp
                    this.Ismissingshipmentflag = (result.data.syncMissingShipments) ?  result.data.syncMissingShipments : false
                }
            })
        },
        GetDeliverySRList(hubid) {
            return new Promise((resolve, reject) => {
                try {
                    this.rvpUserLoading = true;
                    this.srArrayList = [];
                    this.srList = [];
                    let RVPPayload = {
                        "usertype": "3",
                        "hubid": [hubid]
                    }
                    getHubDeliverySRListByHubID(RVPPayload, (result) => {
                        try {
                            this.srArrayList = result.data.data.results;
                            for (var i = 0; i < this.srArrayList.length; i++) {
                                this.srList.push({
                                    value: this.srArrayList[i].userid,
                                    text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                                    OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
                                    EmpType: this.srArrayList[i].EmpType,
                                    CourierCompanyID: this.srArrayList[i].CourierCompanyID,
                                    MobileNumber: this.srArrayList[i].MobileNumber,
                                    IsSRNeedTrip: this.srArrayList[i].isTripAllowedForSR,
                                    isselfieverified: typeof(this.srArrayList[i].isselfieverified) != "undefined" ? this.srArrayList[i].isselfieverified : true,
                                    ishvonboardingdone: typeof(this.srArrayList[i].ishvonboardingdone) != "undefined" ? this.srArrayList[i].ishvonboardingdone : true,            
                                })
                            }
                            
                            this.hyperVMsgData = {
                                hvOnboardingFailMsg: result.data.data.hvonboardingfailmsg,
                                hvSelieFailMsg: result.data.data.hvselfiefailmsg,
                            }
                            this.rvpUserLoading = false;
                        } catch (e) {
                            this.rvpUserLoading = false;
                            console.log('Error------', e);
                        }
                    })
                    resolve(true);
                } catch (err) {
                    this.rvpUserLoading = false;
                    console.log('Error Logs For GetDeliverySRList', err);
                    resolve(false);
                }
            })
        },

        GetMissingShippmentList() {
            return new Promise((resolve, reject) => {
                try {
                    let RVPPayload = { "hubId": parseInt(this.userHubId) }
                    getMissingRvpShipmentByHubID(RVPPayload, (result) => {
                        try {
                            if(result.data.code == 200){
                                
                                let hubids = window.localStorage.getItem('missinghubids');
                                // Step 1: Split it into an array (returns an array with one empty string element)
                                let arr = hubids ? hubids.split(",") : []; // This ensures it's an empty array if the string is truly empty

                                // Step 2: Modify the array (e.g., add an item)
                                arr.push(this.userHubId);

                                // Step 3: Convert it back to a string
                                let newStr = arr.join(",");
                                window.localStorage.setItem('missinghubids',newStr)
                                resolve(true)
                            }else{
                                resolve(false)
                            }
                        } catch (e) {
                            console.log('Error------', e);
                        }
                    })
                    resolve(true);
                } catch (error) {

                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/components/newallocationpagev2/newallocationpagev2.component.js